export const EDITOR_MODAL_STORIES_TAB_MY_STORIES = 'My Stories';
export const EDITOR_MODAL_STORIES_TAB_TEAM_STORIES = 'Team';
